// routes
import Router from '../shared/routes';
// theme
import ThemeProvider from '../theme';
// components
import ThemeSettings from '../shared/components/settings';
import { ScrollToTop, ProgressBarStyle, Toast } from '../shared/components/base';
import MotionLazyContainer from '../shared/components/animate/MotionLazyContainer';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <ThemeSettings>
          <ProgressBarStyle />
          <ScrollToTop />
          <Router />
          <Toast />
        </ThemeSettings>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}
